var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComblesNonAmenages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.35 30.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c7a00d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.67,29.77c0-.25-.39-.43-.57-.56-.25-.17-.76-.63-1.05-.52-.04-.03-.07-.08-.11-.11,0,0,.03-.14-.07-.22-.67-.53-1.53-1.04-2.3-1.4l-.26-.32H8.22l-.26.32c-.46.09-1.43-.27-1.51.32l-5.02,3.31c-.59-.6-2.19-2.14-.99-2.8L46.93.08l.34-.08,46.99,28.32.09.3-1.13,2.12c-.16.04-1.31-.81-1.55-.96ZM46.68,2.8c-11.29,6.88-22.76,13.55-34.2,20.17-.5.29-1.01.57-1.51.86-.1.06-.2.14-.32.22-.49.3-1.34.61-1.77.99-.13.12-.16.12-.17.31,0,.06,0,.21,0,.22.08.06,1.73.01,2,0,12.63-.39,25.37-.17,38.02-.22.14,0,.29,0,.43,0,1.04,0,2.09,0,3.13,0,1.19,0,2.37,0,3.56,0,1.9,0,3.85-.09,5.72-.11.11,0,.22,0,.32,0s.31,0,.43,0c3.38-.03,6.76.02,10.14,0v-6.26c-.2-.02-.34.12-.5.2-3.51,1.84-6.87,4.12-10.39,5.95-1.9-.08-3.85.07-5.72.11-1.11.02-2.23,0-3.34,0v-.11c.18-.13.32-.3.54-.38l16.36-8.33,8.45,4.72v3.99c2.44.06,4.9-.08,7.34,0,.31.01.49.25.43-.11l-8.63-4.86c-.08-.12-.21-.15-.32-.22l-12.3-7.23c-.1-.06-.2-.14-.32-.22.03-.26-.42-.4-.62-.52-1.51-.9-3.14-1.96-4.68-2.77-.15-.08-.24-.21-.42-.06-.1-.06-.2-.14-.32-.22.06-.27-.14-.22-.28-.3-.32-.19-.87-.68-1.23-.56-.1-.06-.2-.14-.32-.22.06-.27-.14-.22-.28-.3-.32-.19-.87-.68-1.23-.56-.29-.17-.57-.37-.86-.54.06-.27-.14-.22-.28-.3-.32-.19-.87-.68-1.23-.56-.1-.06-.2-.14-.32-.22.06-.27-.14-.22-.28-.3-.32-.19-.87-.68-1.23-.56-.1-.06-.2-.14-.32-.22.06-.27-.14-.22-.28-.3-.32-.19-.87-.68-1.23-.56-.1-.05-.19-.14-.32-.22.06-.27-.14-.22-.28-.3-.71-.44-.61-.57-1.33-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.95 26.97 8.22 26.64 87.3 26.64 87.57 26.97 7.95 26.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.37,12.73l12.3,7.23c-4.08-2.41-8.21-4.82-12.3-7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.99,20.17l8.63,4.86c.06.36-.12.12-.43.11l-8.2-4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.57,25.13v.11c-1.87.01-3.82.1-5.72.11v-.11c1.87-.04,3.81-.19,5.72-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.33,9.17c.18-.15.27-.02.42.06,1.54.81,3.17,1.86,4.68,2.77.19.12.64.26.62.52-1.89-1.11-3.82-2.23-5.72-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.65,24.06c.06.27-.14.22-.28.3-.55.34-1.1.68-1.66.99.02-.19.04-.19.17-.31.42-.38,1.28-.69,1.77-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.51,25.24c1.11,0,2.23.02,3.34,0v.11c-1.19,0-2.37,0-3.56,0v-.11h.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.49,22.98c.06.27-.14.22-.28.3-.32.19-.87.68-1.23.56.5-.29,1.01-.57,1.51-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.5,8.09c.36-.12.91.36,1.23.56.14.09.34.04.28.3-.5-.29-1.01-.57-1.51-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.66,7.01c.36-.12.91.36,1.23.56.14.09.34.04.28.3-.5-.29-1.01-.57-1.51-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.29,5.61c.36-.12.91.36,1.23.56.14.09.34.04.28.3-.5-.29-1.01-.57-1.51-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.46,4.53c.36-.12.91.36,1.23.56.14.09.34.04.28.3-.5-.29-1.01-.57-1.51-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.62,3.45c.36-.12.91.36,1.23.56.14.09.34.04.28.3-.5-.29-1.01-.58-1.51-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.68,2.8c.73-.44.62-.31,1.33.13.14.09.35.04.28.3-.5-.27-1.05-.64-1.62-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.16,25.24v.11c-.14,0-.29,0-.43,0v-.11h.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.32,25.24c-.12,0-.32,0-.43,0h.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.51,25.13v.11h-.22c.03-.11.18-.08.22-.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.37 21.14 24.82 16.42 40.75 24.54 41.94 25.24 32.71 25.24 21.76 18.99 21.76 25.24 16.37 25.24 16.37 21.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.16,25.24h-.43c-1.08,0-2.16,0-3.24,0-.04-6.75-.22-13.53-.05-20.28.27-.25,1.56-1.87,1.82-1.83.61.61,1.37,1.12,1.9,1.77v20.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComblesNonAmenages);
export default __webpack_public_path__ + "static/media/combles-non-amenages.a667a430a04dc1cd5cdadb9650f7d9c8.svg";
export { ForwardRef as ReactComponent };